


































import { Component, Mixins, Prop, Emit } from 'vue-property-decorator'
import { ApiGeneralSinglePayload } from '@/tcw/api/types'
import Getsudo from '@/tcw/domain/Getsudo'
import TcwGetsudoPicker from '@/components/common/TcwGetsudoPicker.vue'
import BaseComponent from '@/tcw/components/BaseComponent'
import KintaiAction from '@/components/kintai/molecules/KintaiAction.vue'
import ShouninStatus from '@/components/kintai/molecules/ShouninStatus.vue'
import { KintaiActionMenu } from '../types'

@Component({
  components: { TcwGetsudoPicker, KintaiAction, ShouninStatus }
})
export default class KintaiLocalHeader extends Mixins(BaseComponent) {
  @Prop({ type: Getsudo, default: null })
  private getsudo!: Getsudo | null
  @Prop({ default: null })
  private teishutsu!: ApiGeneralSinglePayload | null
  @Prop({ default: () => [] })
  private actions!: KintaiActionMenu[]
  @Prop({ type: Boolean, default: () => false })
  private processingAction!: boolean

  private get getsudoValue(): Getsudo {
    return this.getsudo ? this.getsudo : Getsudo.now(this.shimebi)
  }

  private get isCurrentMonthMonth(): boolean {
    return this.getsudoValue.isSameMonth(new Date(), this.shimebi)
  }

  @Emit()
  private nextMonth() {
    /** */
  }
  @Emit()
  private prevMonth() {
    /** */
  }
  @Emit()
  private toCurrentGetsudo() {
    /** */
  }
  @Emit()
  private selectGetsudo(getsudo: Getsudo) {
    this.updateGetsudo(getsudo)
  }
  @Emit('update:getsudo')
  private updateGetsudo(_getsudo: Getsudo) {
    /** */
  }

  @Emit()
  private selectAction(_command: string) {
    /** */
  }

  @Emit()
  private clearKintaiCheckMode(): void {
    /** */
  }
}
